const validate = values => {
		const errors = {};
		const requiredFields = [ 'username', 'email', 'confirm_email', 'password', 'confirm_password', 'terms' ];
		// const requiredFields = [ 'email', 'confirm_email', 'password', 'confirm_password', 'terms' ];
		requiredFields.forEach(field => {
				if (!values[field]) { errors[ field ] = 'Required'; }
		});
		if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
				errors['email'] = 'Invalid email address';
		}

 if (!values.terms) { errors['terms'] = 'Must agree To Terms & Conditions' }
		if (values.confirm_email !== values.email) { errors['confirm_email'] = 'Email Addresses must match'; }
		if (values.confirm_password !== values.password) { errors['confirm_password'] = 'Passwords must match'; }
		if (values.password && values.password.length < 8) { errors['password'] = 'Minimum of 8 characters'; }
		return errors;
}

export default validate;



// WEBPACK FOOTER //
// ./src/app/containers/Register/validators.ts